// PrimaryNavV3 — F9.6 WAVE 2F · horizontal top-bar primary navigation
// for AUTHENTICATED users. Visible between the logo and the right-side
// widgets (globe · cart · bell · plan badge · credits pill · avatar).
//
// Visibility matrix:
//   • Mobile <768px        → hidden entirely (fallback: AdminMegaDropdown on avatar)
//   • Tablet 768-1023px    → shows only items with responsive="always"
//                            (workspace · creator · admin*)
//   • Desktop ≥1024px      → shows ALL items (7 for admin, 6 for non-admin)
//
// The AdminMegaDropdown (avatar) remains the exhaustive quick-access panel.
// This primary nav is a lighter horizontal surface for the most common
// top-level groups.
import React from "react";
import { useAuth } from "@/context/AuthContext";
import { isAdminRole } from "@/data/v12_user_nav";
import PrimaryNavItem from "./PrimaryNavItem";
import { PRIMARY_NAV_ITEMS } from "./primaryNavData";

export default function PrimaryNavV3() {
    const { user, hasModule } = useAuth();
    if (!user || user === false) return null;

    const isAdmin = isAdminRole(user?.role);
    const visibleItems = PRIMARY_NAV_ITEMS.filter((item) => !item.adminOnly || isAdmin);

    return (
        <nav
            className="hidden md:flex items-center gap-1"
            aria-label="Primary"
            data-testid="primary-nav-v3"
        >
            {visibleItems.map((item) => (
                <PrimaryNavItem
                    key={item.key}
                    item={item}
                    isAdmin={isAdmin}
                    hasModule={hasModule}
                />
            ))}
        </nav>
    );
}
